import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 3H3v18h18V3zm-6 6h-4v2h4v2h-4v2h4v2H9V7h6v2z"
}), 'ExplicitSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ExplicitSharp.js
// module id = 3451
// module chunks = 2